export default {
    lang: 'zh',
    serverError: '服务器错误，错误代码500！',
    enterPhoneNumber: '请输入手机号',
    enterPhoneNumberOrEmail: '请输入手机号/邮箱',
    phoneNumber: '手机号',
    enterAccount: '请输入账号',
    noChineseAllowed: '请输入正确的手机号或邮箱',
    noSpecialCharsAllowed: '不能包含特殊字符',
    onlyDigitsAllowed: '只能包含数字',
    yiyouzhanghao: '已有账号？',
    xiangqilaile: '想起来了，去',
    qudenglu: '登录',
    login: '登录',
    yuedutongyi: '我已阅读并同意',
    yonghufuwuxieyi: '《用户服务协议》',
    yinsixieyi: '《隐私协议》',
    dunhao: '、',
    gouxuantongyixieyi: '请先勾选同意《用户服务协议》、《隐私协议》',
    zhanghaogeshicuowu: '输入的账号格式不符合要求',
    qingshuruzhengquedeshoujihao: '请输入正确的手机号',
    pleaseEnterValidPhoneNumber: '请输入正确格式的手机号',
    jiaoyanyonghucuowu: '校验用户身份错误，请稍后再试',
    yonghuyizhuce: '用户已经注册',
    yonghuweizhuce: '用户未注册',
    yixiangninfasong: '已向您的手机号',
    qingchashouyanzhengma: '发送4位短信验证码，请注意查收',
    xiugaizhanghao: '修改账号',
    fasongyanzhengma: '发送验证码',
    houkechongfaqian: '',
    houkechongfahou: '后可重发',
    haikeyihuoqu: '还可以获取',
    ciyanzhengma: '次验证码',
    weilezhanghaoanquan: '为了您的账号安全，请为账号',
    shezhimimajuhao: '设置密码。',
    shezhimima: '设置密码',
    zhengzaiweizhanghao: '正在为账号',
    shezhixinmima: '设置新密码',
    qingshurumima: '请输入密码',
    zhishao: '至少 ',
    zhishaoweishu: ' 位',
    zhiduo: '最多 ',
    baohanshuzi: '包含数字',
    baohanzimu: '包含字母',
    baohandaxiaoxiezimu: '包含大小写字母',
    baohanteshuzifu: '包含特殊字符',
    zaicishurumima: '再次输入密码',
    queding: '确定',
    mimachangdutishi: '密码需要10-20位，包含数字、大小写字母、特殊字符',
    qingzaicishurumima: '请再次输入密码',
    liangcimimabuyizhi: '两次输入的密码不一致!',
    chongzhichenggongtiaozhuan: '重置密码成功，即将跳转',
    chongzhichenggong: '重置密码成功',
    ruhechenghunin: '我们该如何称呼您？',
    qingshuruxingming: '请输入姓名',
    wancheng: '完成',
    zhucechenggong: '注册成功',
    xmiaohoudengluqian: '',
    enterEmail: '请输入邮箱',
    pleaseEnterEmail: '请输入邮箱地址',
    emailFormatError: '邮箱格式不正确',
    useEmailInstead: '使用邮箱',
    usePhoneInstead: '使用手机号',
    useEmailSignup: '使用邮箱注册',
    usePhoneSignup: '使用手机号注册',
    useEmailFindpwd: '使用邮箱找回',
    usePhoneFindpwd: '使用手机号找回',
    hasSentEmailTo: '已向您的邮箱',
    pleaseCheckEmail: '发送了一封邮件，请前往邮箱完成验证（1天内有效）。',
    xmiaohoudengluhou: '秒后将自动登录',   //看一下效果
    mimadenglu: '密码登录',
    yanzhengmadenglu: '验证码登录',   
    fouryanzhengma: '4位验证码',
    jizhumima: '记住密码',
    wangjimima: '忘记密码',
    qitalogin: '其他方式登录',
    wechatdenglu: '微信登录',
    wechatdenglutips: '使用微信扫码登录，安全便捷',
    wechatshouquan: '微信授权登录',
    wechatdenglufooter: '登录即表示同意《用户服务协议》和《隐私协议》',
    yonghushoujibangding: '用户手机绑定',
    yonghushoujibangdingyudaokunnan: '用户手机绑定遇到困难？',
    yonghushoujibangdingchenggong: '手机绑定成功！',
    zhuce: '注册',
    shezhinicheng: '设置昵称',
    gaizenmechenghunin: '我们该怎么称呼您？',
    denglutixing: '登录提醒',
    yizaiqitadifangdenglu: '您的账号已在其他地方登录，为保障您的账号安全，本次登录将会将其他的登录踢出。如果这不是您的操作，请尽快修改您的密码并注意账号安全。',
    quxiao: '取消',
    jixudenglu: '继续登录',
    dengluxietong: '登录协同',
    huoquyanzhengma: '获取验证码',
    qingshuruyanzhengma: '请输入验证码',
    yanzhengmaweishuzi: '验证码必须为数字值',
    yanzhengmageshicuowu: '验证码格式不正确',
    chongxinfasong: '重新发送',
    yanzhengmadashangxian: '验证码发送次数已达到上限，2小时后可再次尝试',
    shiyongwangjimima: '请使用忘记密码功能修改密码',
    baxianSystemFirstcontent: '协同交付平台·让管理工作不再复杂',
    baxianSystemSecondcontent: '项目·任务·文档·沟通·工具',
    maliangSystemFirstcontent: '用数字重新定义设计',
    maliangSystemSecondcontent: 'Redefine design with data',
    dayuSystemFirstcontent: '数据智能基础平台',
    dayuSystemSecondcontent: '让数据服务更加智能',
    jiuzhouSystemFirstcontent: '建筑与城市空间平台',
    jiuzhouSystemSecondcontent: '建筑、园区、市政、城市数据汇集、融合、共享',
    
    gong: '共', //未处理
    tiao: '条', //未处理
    ye: '页', //未处理

    zhanghaoshangweizhuce: '该账号尚未注册',
    zhanghaoyijingcunzai: '注册的账号已存在',
    shoujihaoweizhuce: '该手机号尚未注册',
    zhanghaogeshibuzhengque: '输入的账号格式不符合要求',
    zhanghaobucunzai: '账号不存在，请检查输入',
    shoujihaoyizhuce: '该手机号已注册',
    yanzhengmacuowu: '验证码错误，请重新填写',
    yangzhengmashixiao: '验证码已失效，请重新获取',
    yanzhengmabucunzai: '验证码不存在，请发送验证码',
    zhanghaomimacuowu: '账号或密码错误',
    xinjiumimayizhi: '新密码与原密码一样',
    tuxingyanzhengmacuowu: '图形验证码错误，请重新填写',
    dengluchushihua: '账号没有设置密码或因系统升级重置密码，请用验证码登录初始化',    
    dengluguoqi: '登录过期，即将跳转登录！',
    qingqiulujingcuowu: '请求路径错误或请求的资源不存在！',
    fuwuqifashengcuowu: '服务器发生错误！',
    qingqiuyichang: '请求异常！',
    wanshanxinxi: '完善信息',
    shuruzhanghao: '输入账号',
    anquanyanzheng: '安全验证',
    zhaohuimimayudaokunnan: '如找回密码遇到困难',
    sendEmail: '可发送邮件至',
    forHelp: '寻求帮助',
    chongzhimima: '重置密码',
    nextStep: '下一步',
    shuruyonghuming: '请输入用户名',
    remen: '热门',
    code86: '中国大陆',
    code852: '中国香港',
    code853: '中国澳门',
    code65: '新加坡',
    code60: '马来西亚',
    shenqingshiyong: '申请试用',
    
    // 邮箱验证相关
    emailVerificationExpired: '邮箱验证失效',
    emailVerificationFailedRetry: '邮箱验证失效，请重试',
    goToHome: '返回首页',
    jinzhishangchuan: '提醒: 禁止上传涉密文件(含工作秘密)!',

}